import { v4 as uuid } from "uuid";

import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'

export const initialState = {
    redirectTo: null,
    changeKey: null
};

const RedirectReducer = createSlice({
  name: 'redirect',
  initialState,
  reducers: {
      redirectTo:  ((state, action) => {
          state.redirectTo = action.payload;
          state.changeKey = uuid().slice(0, 8);
      }),
      
      resetState:  ((state = null, action = null) => {
          state.redirectTo = null
      })
    // omit existing reducers here
  },
  extraReducers(builder) {
    
  }
});


export const { resetState, redirectTo } = RedirectReducer.actions;
export default RedirectReducer.reducer